import React, { Component } from 'react';
import { connect } from 'react-redux';
import './document.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as repositoryActions from '../../../../Store/Actions/repositoryActions';
import * as sidebarActions from '../../../../Store/Actions/sidebarActions';
//import * as tdiobjectActions from '../../Components/TDIObject/tdiobjectActions';

//Components
import Sidebar from '../../../Containers/sideBar';
import TreeView from '../../../Components/TreeView/treeview';
import ListView from '../../../Components/ListView/listview';
import PopupBox from '../../../Components/PopupBox/popupbox';
import treeview from '../../../Components/TreeView/treeview';
import ModalForm from '../../../Components/Modal/modal';


class DocumentView extends Component {
  constructor(props) {
    super(props);

    this.state = {
      page:0,
      name:"Document",
      objects:[],
      showForm:false,
      activeAction:null,
      listviewConfig:{
        id:"ARCS",
        isSelectable:false,
        columns:[
          {
            name:"TYPE",
            displayName:"Type",
            type:"Text",
          },
          {
            name:"CODE",
            displayName:"Code",
            type:"Text",
            state:"ReadOnly",
            unique:true,
          },
          {
            name:"WORDING",
            displayName:"Wording",
            type:"Text"
          }
        ],
        actions:[
          "Update",
          "Archive",
          "Add",
        ]
      },
      activeNode:{
        name:"Document Library",
        type:"DOC",
        children:[],
        config:{
          id:"ARCS",
          isSelectable:false,
          columns:[
            {
              name:"TYPE",
              displayName:"Type",
              type:"Text",
            },
            {
              name:"CODE",
              displayName:"Code",
              type:"Text",
              state:"ReadOnly",
              unique:true,
            },
            {
              name:"WORDING",
              displayName:"Filename",
              type:"Text"
            }
          ],
          actions:[
            "Update",
            "Archive",
            "Add",
          ]
        },
        endpoint:"DOC",
        objects:null,
      },
      formData:{name:"",create:false,object:null},
      parentId:null,
      selectedObjectId:0,
      mocks:[],
    }
  }
 

  getDataSet = (node) =>{
    var parent_id = null;
    if(typeof node.endpoint !== "undefined"){
      // IF NODE.SUBTYPE IS NOT EMPTY GET THE TDI ID RELATED
      if(node.subType !== undefined){
        if(this.props.TDIObjects.filter(item=>item.CODE ===node.subType).length>0){
          node.ARCS_TP_N3 = this.props.TDIObjects.find(item=>item.CODE ===node.subType).ARCS;
          
          if(node.parent !== undefined){
            parent_id =  this.props.TDIObjects.find(item=>item.CODE ===node.parent).ARCS;
            
          }
          
        }
        
      }
      console.log("Document");
      this.props.get_list_object(this.props.sessionId,node.endpoint,node,this.state.page);
    }else{
      this.props.clean_data();
    }
    this.setState({listviewConfig:node.config,activeNode:node, parentId:parent_id});
  }


  onSelectListItem= (action) =>{
    switch(action.action){
      case "Update":
        console.log("Update Object",action,this.state.activeNode);
        //this.props.get_single_object(this.props.sessionId,action.object[action.config.id],this.state.activeNode.endpoint);
        var formData = {...this.state.formData};
        formData.create=false;
        formData.name=this.state.activeNode.name;
        this.setState({showForm:true,activeAction:action,formData:formData,selectedObjectId:action.object.ARCS});
        break;
      case "Add":
        // LOAD BLANK OBJECT
        //var blankObject = {...this.props.blankObjects[this.state.activeNode.type]};
        //blankObject.ARCS_TP_N3 = this.state.activeNode.ARCS_TP_N3;
        //this.props.create_single_object(this.props.sessionId,blankObject);
        console.log("ADD Object");
        var formData = {...this.state.formData};
        formData.name=this.state.activeNode.name;
        formData.create=true;
        this.setState({showForm:true,activeAction:action,formData:formData});
        break;
      case "Archive":
        // CONFIRM ARCHIVE
        console.log("Archive Object",action);
        this.props.delete_single_object(this.props.sessionId,action.object[action.config.id],this.state.activeNode,action.object);
        // ETAT 255 -> FLAG 255
        this.setState({showForm:false,activeAction:action});
        break;
      case "Unarchive":
        // CONFIRM UNARCHIVE
        console.log("Unarchive Object",action);
        this.props.unarchive_single_object(this.props.sessionId,action.object[action.config.id],this.state.activeNode,action.object,this.props.pagination);
        // ETAT 0 -> FLAG 0
        this.setState({showForm:false,activeAction:action});
        break;
      default:
        break;
    }
  } 



  onClosePopup = () =>{
    if(this.props.newObject.ARCS ===0){
      console.log("nothing to release"); 
      this.props.onCloseForm();
    }else{
      console.log("objectToRelease",this.props.loadedObject);
      this.props.save_single_object(this.props.sessionId,{...this.props.loadedObject}.ARCS,this.state.activeNode,{...this.props.loadedObject});
      this.props.onCloseForm();
    }
    this.setState({showForm:false,activeObject:null,selectedObjectId:0});
    
  }

  onPopupSave = () =>{
    this.props.save_single_object(this.props.sessionId,{...this.props.newObject}.ARCS,this.state.activeNode,{...this.props.newObject});
    this.props.onCloseForm(); 
    this.setState({showForm:false,activeObject:null});
  }

  // BUILDING METHOD
  componentDidMount = () =>{
    // LOAD STRUCTURE
    //this.props.get_list_object(this.props.sessionId,"TDI",null);
    this.props.init_mock(this.state.mocks);
    //this.props.toggleSidebar(false);

  }

  buildingSubLevel = () =>{

  }

  buildContent = () =>{
    console.log("WorkingData",this.props.workingData);
    var content = 
    <div className={this.props.sidebarShow ? "Container sideBarOn" : "Container sideBarOff"}>
      <div className="view-content">
        {this.props.workingData.length>0?<ListView toolbarReturn={this.onSelectListItem.bind()} onSelectItem={null} config={this.state.listviewConfig} listItem={this.props.workingData}/>:null}
        <div className={this.props.loading?"loader show":"loader"}><div><FontAwesomeIcon icon="spinner"/></div></div>
      </div>
    </div>;

    return content;
  }

  render() {
    var content = this.buildContent();
    var popupConfig = this.state.activeAction !== null? this.state.activeAction.config:{};
    

    if(this.state.activeAction !== null){
      popupConfig.action = this.state.activeAction.action;
      popupConfig.object = this.state.activeAction.object;
      if(popupConfig.columns.filter(item=>item.unique).length>0){
        
        var workingDataSet = this.props.workingData;
        popupConfig.columns.filter(item=>item.unique).forEach(column=>
          {
            column.reservedValue = workingDataSet.map(item=>{return item[column.name]});
          }
        );
      }
    }

    return (
      <div className="Documentpage View">
        <Sidebar>
        </Sidebar>
        {content}
        {this.state.showForm?
          <ModalForm 
                    onSaveData={this.onPopupSave.bind()}
                    show={this.state.showForm}
                    data={this.state.formData}
                    id={this.state.selectedObjectId} 
                    node={this.state.activeNode} // FORM TO BE LOADED
                    onHandleClose={this.onClosePopup.bind()}
                    parentId={this.state.parentId}
          >
          </ModalForm>:null
        }
      </div>
    );
  }
}
const mapStateToProps = (state) => {
  return {
      newObject:state.apiReducer.newObject,
      sessionId: state.apiReducer.sessionId,
      workingData:state.apiReducer.workingData,
      loading:state.appReducer.loading,
      nodes:state.appReducer.nodes,
      loadedObject:state.apiReducer.loadedObject,
      blankObjects:state.apiReducer.blankObjects,
      TDIObjects:state.apiReducer.TDI,
      sidebarShow: state.appReducer.sidebarShow,
  }
}
const mapDispatchToProps = (dispatch) => {
  return {
    get_list_object: (sessionId,endPoint,node,page) =>dispatch(repositoryActions.get_list_object(sessionId,endPoint,node,page)),
    get_single_object: (sessionId,id,endPoint) =>dispatch(repositoryActions.get_single_object(sessionId,id,endPoint)),
    save_single_object: (sessionId,id,endPoint,object,page) =>dispatch(repositoryActions.save_single_object(sessionId,id,endPoint,object,page)),
    delete_single_object: (sessionId,id,endPoint,object,page) =>dispatch(repositoryActions.delete_single_object(sessionId,id,endPoint,object,page)),
    unarchive_single_object: (sessionId,id,endPoint,object,page) =>dispatch(repositoryActions.unarchive_single_object(sessionId,id,endPoint,object,page)),
    create_single_object:(sessionId,object) =>dispatch(repositoryActions.create_single_object(sessionId,object)),
    clean_data: () => dispatch(repositoryActions.clean_data()),
    onCloseForm:() => dispatch(repositoryActions.onCloseForm()),
    init_mock:(data) => dispatch(repositoryActions.init_mock(data)),
    toggleSidebar:(data) =>dispatch(sidebarActions.toggleSidebar(data)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(DocumentView);


